import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import diplomats_Campaigner_ENFP_personality_header from '../../images/personality_types_details/diplomats_Campaigner_ENFP_personality_header.svg'
import diplomats_Campaigner_ENFP_workplace_habits from '../../images/personality_types_details/diplomats_Campaigner_ENFP_workplace_habits.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const enfps_at_work = () => {
    return (
        <Layout>
            <main class="q-td analyst campaigner">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/compaigner-enfp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfps-at-work" className="tab with-progress active">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/compaigner-enfp-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header diplomat campaigner">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={diplomats_Campaigner_ENFP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Campaigner</span> Personality</h1>
                        <div class="code">ENFP-A / ENFP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>

                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/compaigner-enfp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-careers">Career Paths</Link></li>
                                <li className="active"><Link to="/personality-types/compaigner-enfps-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/compaigner-enfp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}

                    <article class="main description">

                        <h1>Workplace Habits</h1>


                        <p>There are two basic things that Campaigners seek most in the workplace: The chance to explore new ideas, and the chance to conduct that exploration alongside other people who share their excitement. These qualities show through at all levels of hierarchy, though much like other Diplomat personality types, Campaigners would prefer that there be hardly a hierarchy at all. People with the Campaigner personality type possess warmth, creativity, and an open-mindedness that makes them excellent listeners. If these qualities are recognized by their employers, they will always be able to count on their Campaigner employees to innovate and boost morale.</p>

                        <div class="scene">
                            <img alt="Campaigner workplace habits" src={diplomats_Campaigner_ENFP_workplace_habits} alt="Campaigner workplace habits" />
                        </div>

                        <h2>Campaigner Subordinates</h2>

                        <p>Campaigners are growth-oriented, and as subordinates they’ll impress their managers with their creativity and adaptability. People with the Campaigner personality type are excellent listeners, able to analyze and understand others’ perspectives effortlessly. It’s perhaps this quality that most makes Campaigners intolerant of micromanagement – the way they see it, they understand what’s been asked of them, and all they require is the freedom to accomplish their task. If this need isn’t met, managers may find a quickly stressed Campaigner subordinate.</p>

                        <p>To a certain extent though, some direct management is often necessary, as Campaigners are notorious for letting their attention slip from one project to the next before they’ve dotted their I’s and crossed their T’s. Campaigners love exploring new ideas and learning new things, and once something becomes familiar, its allure starts to fade. But, if managers are able to maintain a spirit of guidance and camaraderie instead of "bossiness", they will find loyal and devoted contributors in their Campaigner subordinates.</p>

                        <h2>Campaigner Colleagues</h2>

                        <p>Campaigners are people-people, and as far as the workplace is concerned, this quality shows through best among colleagues. More than just coworkers, Campaigners view their colleagues as friends, people who they take a genuine interest in, providing support and cheer when they’re down or stressed. People with the Campaigner personality type are warm and optimistic, always searching for and usually finding win-win situations for everyone.</p>

                        <p>Brainstorms among equals are Campaigners’ forte, and they listen to different viewpoints and suggestions not just with tolerance, but genuine excitement. Their ability to relax and have fun will always make them popular around the water cooler, but what sets Campaigners apart is that they can transition that popularity into natural leadership, instinctively picking up on colleagues’ motivations and pulling their teams together, pushing them forward towards whatever truth they’ve been tasked to find.</p>

                        <h2>Campaigner Managers</h2>

                        <p>Campaigners are not great fans of heavy hierarchy and bureaucracy, and this is most evident when they take on the role of manager. As managers, Campaigner personalities behave much like they do as colleagues – they establish real friendships, and use their broad popularity to inspire and motivate, taking on the role of leader, working alongside their subordinates, rather than shouting from behind their desks. Campaigners will tend to believe in the concept of intrinsic motivation, the idea that things are worth doing for their own sake, not because of some convoluted system of punishments and rewards.</p>

                        <p>Unfortunately, not everyone buys into this philosophy – challenges arise when faced with subordinates who actually prefer to be closely directed, with clearly defined objectives and timetables, people who are just doing their jobs. More challenging still are those rare moments when a reprimand is simply necessary – while Campaigners prefer to meet dissent with an open ear, and to use their excellent capacity for sensing mood and morale to preempt such an act to begin with, sometimes the carrot and the stick are necessary, and using them is the biggest challenge for the Campaigner personality type. But Campaigners’ capacity for adjusting their communication to most any style will always shine through, helping to smooth things over and adapt to the needs of their team.</p>

                        <div class="number">07</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/compaigner-enfp-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/compaigner-enfp-conclusion' className='next-feature'>
                            Conclusion
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default enfps_at_work
